export default __webpack_public_path__ + "assets/images/bg-icon2-48217105.png";